import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import LocationAutocomplete from "../../../components/common/InputField/LocationAutocomplete";
import MainButton from "../../../components/common/MainButton/MainButton";
import Heading from "../../../components/common/Typography/Heading";
import Alerts from "../../../components/common/Alerts/Alerts";
import Spinner from "../../../components/common/Spinner";
import { setField, setStep } from "../../../Redux/Slice/SignUp";
import { LocationSchema } from "../../../FormValidations/SignUpSchema";
import { UpdateUserMutation } from "../../../services/SignUp";
import { useGraphQL } from "../../../context/GraphQLProvider";
import StepBackButton from "../../../components/common/StepBackButton/StepBackButton";
import { POPUP_FORM_CONTENT_CLASS } from "../../../components/popup/popupLayoutSpec";
import { transformToUserInput } from "../../../utils/userInputUtils";

const Location = ({ onClickHandler }) => {
    const graphqlService = useGraphQL();
    const [RequestStart, setRequetStart] = useState(false);
    const dispatch = useDispatch();
    const InitialValues = useSelector((state) => state.signup);
    const { id, email, step } = useSelector((state) => state.signup);

    const UpdatePersonalDetails = (gql, location) => {
        const userInput = transformToUserInput(InitialValues);
        userInput.userInput.location = location;

        UpdateUserMutation(gql, userInput)
            .then((response) => {
                if (response.updateUserProfile?.location === location) {
                    onClickHandler();
                }
            })
            .catch((error) => {
                Alerts.error(error);
            })
            .finally(() => {
                // onClickHandler();
                setRequetStart(false);
            });
    };

    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: LocationSchema,
        onSubmit: (values, { resetForm }) => {
            dispatch(setField(values));
            setRequetStart(true);
            const location = values.location;
            UpdatePersonalDetails(graphqlService, location);
        },
    });
  
    return (
        <>
            {RequestStart && <Spinner />}
            <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                <div className={POPUP_FORM_CONTENT_CLASS}>
                    <Heading
                        variant={"h6"}
                        className={
                        "flex items-center justify-center text-center text-offblack"
                        }
                    >
                        Set your location
                    </Heading>
                    <div className="mt-10 xl:mt-[60px] w-full">
                        <form>
                            <div className="flex justify-center w-full">
                                <div className="w-full mx-auto">
                                    <LocationAutocomplete
                                        variant={"general"}
                                        fullWidth
                                        label={"Location"}
                                        name="location"
                                        value={formik.values.location}
                                        placeholder={"Start typing your suburb or postcode."}
                                        star={true}
                                        onChange={(value) => formik.setFieldValue('location', value)}
                                        error={formik.touched.location && formik.errors.location ? formik.errors.location : null}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-center w-full">
                                <div className="w-full mx-auto">
                                    <div className="flex items-center justify-between mt-10 w-full">
                                        <StepBackButton onClick={() => dispatch(setStep(step - 1))} />
                                        <MainButton
                                            variant={"small"}
                                            onClick={formik.handleSubmit}
                                        >
                                            Next
                                        </MainButton>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Location;
